export default "__VITE_ASSET__c9c7a501__"